import { render, staticRenderFns } from "./TheEducation.vue?vue&type=template&id=1bb81974&scoped=true&"
import script from "./TheEducation.vue?vue&type=script&lang=js&"
export * from "./TheEducation.vue?vue&type=script&lang=js&"
import style0 from "./TheEducation.vue?vue&type=style&index=0&id=1bb81974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb81974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
